var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Activities", style: { padding: _vm.isSchool && "0 10px" } },
    [
      _c(
        "tabs",
        {
          attrs: {
            showBorderBottom: "",
            "tabs-list": _vm.activitiesInfo,
            "active-tab": _vm.activeTab
          },
          on: { changed: _vm.changeTab }
        },
        [
          _c(_vm.activeTab, {
            tag: "component",
            attrs: { "is-school": _vm.isSchool }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e33842e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e33842e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/pages/Activities/Activities.vue
// module id = null
// module chunks = 